/**
 * Copyright 2025 Beijing Volcano Engine Technology Co., Ltd. All Rights Reserved.
 * SPDX-license-identifier: BSD-3-Clause
 */

import { memo, useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import ModeSwitch from '@/components/ModeSwitch';
import { RootState } from '@/store';
import styles from './index.module.less';

type MobileToolBarProps = {
  sceneName: string;
  statusText: string;
};

function MobileToolBar({ sceneName, statusText }: MobileToolBarProps) {
  const [modeTrayOpen, setModeTrayOpen] = useState(false);
  const interactionMode = useSelector((state: RootState) => state.room.interactionMode);

  // Close tray when mode changes
  useEffect(() => {
    setModeTrayOpen(false);
  }, [interactionMode]);

  return (
    <div className={styles.wrapper}>
      <div className={styles.modeSwitchRail}>
        <button
          type="button"
          className={`${styles.modeTrayTrigger} ${modeTrayOpen ? styles.modeTrayTriggerActive : ''}`}
          onClick={() => setModeTrayOpen(!modeTrayOpen)}
        >
          模式切换
        </button>
      </div>
      <div
        className={`${styles.mobileModeTray} ${modeTrayOpen ? styles.mobileModeTrayOpen : ''}`}
      >
        <ModeSwitch compact ghost className={styles.modeSwitch} />
      </div>
      <div className={styles.identityBlock}>
        <div className={styles.sceneLabel}>{sceneName}</div>
        <div className={styles.statusText}>{statusText}</div>
      </div>
    </div>
  );
}
export default memo(MobileToolBar);
